import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'activeDialableProspects',
  type: 'prospect',
}

const formatting = {
  format: {
    title: 'Active Dialable Prospects',
  },
}

const keys = {
  componentKeys: [DATA_METRICS],
  healthKey: 'prospect_health',
}

const activeDialableProspects = {
  metaData: Object.assign(identifiers, formatting, keys),
}

export { activeDialableProspects }
